module.exports = "/_next/static/images/maintenance-cebuana-0aee91ff7b5bcd60c004cb44af99b8ca.svg";